import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import samplePDF from './mentions.pdf';
import "react-pdf/dist/esm/Page/AnnotationLayer.css"
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function Mentions() {
  const [numPages, setNumPages] = React.useState(null);

  return (
    <div className='shrink-0 max-w-4xl mx-auto mt-6'>
      <Document
        file={samplePDF}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
      >
        {Array.from({ length: numPages }, (_, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} renderTextLayer={false} height={1267}/>
        ))}
      </Document>
    </div>
  );
}

export default Mentions;
